import React, { useState, useEffect } from "react";
import { Spin, Button, Popconfirm, message, Empty, Tag } from "antd";
import { ReloadOutlined, CheckOutlined, SwapOutlined } from "@ant-design/icons";
import { corTipoTransferencia } from "./Usetransferencianotificacoes";

// ── Hook de responsividade (mesmo padrão do Dashboard/Notificacoes) ────────
function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== "undefined" && window.innerWidth <= breakpoint
  );
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth <= breakpoint);
    window.addEventListener("resize", handler);
    handler();
    return () => window.removeEventListener("resize", handler);
  }, [breakpoint]);
  return isMobile;
}

const corPrograma = (nome = "") => {
  const n = nome.toLowerCase();
  if (n.includes("livelo")) return "#e8008b";
  if (n.includes("smiles")) return "#ff6600";
  if (n.includes("latam")) return "#d81a36";
  if (n.includes("azul")) return "#003087";
  if (n.includes("itaú") || n.includes("itau")) return "#d48c0c";
  if (n.includes("tap")) return "#009900";
  if (n.includes("esfera")) return "#8b0000";
  return "#607d8b";
};

const LogoCircle = ({ nome, size = 32 }) => (
  <span
    style={{
      display: "inline-flex", alignItems: "center", justifyContent: "center",
      width: size, height: size, borderRadius: "50%", flexShrink: 0,
      background: corPrograma(nome), color: "#fff",
      fontSize: size * 0.34, fontWeight: 700, letterSpacing: "-0.02em",
    }}
  >
    {(nome || "??").replace(/[^a-zA-ZÀ-ÿ]/g, "").slice(0, 2).toUpperCase()}
  </span>
);

export const NotificacoesTransferencia = ({ controller }) => {
  const isMobile = useIsMobile();

  if (!controller) {
    return <div style={{ padding: 24, color: "#999" }}>Alertas indisponíveis.</div>;
  }
  const { itens, resumoPorTipo, total, loading, marcando, carregar, marcarEntrada } = controller;

  const handleMarcar = async (transId) => {
    try {
      await marcarEntrada(transId);
      message.success("Transferência marcada como entrada realizada.");
    } catch (e) {
      message.error(String(e?.response?.data || e?.message || "Erro ao marcar entrada"));
    }
  };

  const s = {
    card: { background: "#fff", borderRadius: 10, boxShadow: "0 1px 4px rgba(0,0,0,0.08)", overflow: "hidden" },
    header: { display: "flex", alignItems: "center", justifyContent: "space-between", padding: isMobile ? "16px 16px 14px" : "18px 22px 16px", borderBottom: "1px solid #f0f0f0", flexWrap: "wrap", gap: 10 },
    body: { padding: isMobile ? 14 : 18 },
  };

  const tipos = Object.entries(resumoPorTipo);

  return (
    <div style={s.card}>
      {/* Cabeçalho */}
      <div style={s.header}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <span style={{ fontSize: 20 }}>🔁</span>
          <div>
            <div style={{ fontSize: isMobile ? 14 : 16, fontWeight: 700, color: "#222" }}>Notificações de Transferência</div>
            {!isMobile && (
              <div style={{ fontSize: 12, color: "#999", marginTop: 1 }}>
                Transferências de milhas pendentes de confirmação de entrada
              </div>
            )}
          </div>
        </div>
        <Button icon={<ReloadOutlined />} onClick={carregar} loading={loading} size="middle">
          Atualizar
        </Button>
      </div>

      <div style={s.body}>
        {/* Barra de resumo — dinâmica por trans_tipo, já que não há níveis de urgência por tempo */}
        {itens.length > 0 && (
          <div style={{ display: "flex", gap: 10, marginBottom: 16, flexWrap: "wrap" }}>
            <div style={{
              display: "flex", alignItems: "center", gap: 8,
              padding: "8px 14px", borderRadius: 8,
              background: "#eef2ff", border: "1px solid #c7d2fe",
              flex: isMobile ? "1 1 100%" : "1 1 140px",
            }}>
              <span style={{ fontSize: 22, fontWeight: 800, color: "#4338ca", lineHeight: 1 }}>{total}</span>
              <span style={{ fontSize: 12, color: "#595959", lineHeight: 1.2 }}>pendentes no total</span>
            </div>
            {tipos.map(([tipo, qtd]) => {
              const nv = corTipoTransferencia(tipo);
              return (
                <div key={tipo} style={{
                  display: "flex", alignItems: "center", gap: 8,
                  padding: "8px 14px", borderRadius: 8,
                  background: nv.corBg, border: `1px solid ${nv.corBorda}`,
                  flex: isMobile ? "1 1 100%" : "1 1 140px",
                }}>
                  <span style={{ fontSize: 22, fontWeight: 800, color: nv.cor, lineHeight: 1 }}>{qtd}</span>
                  <span style={{ fontSize: 12, color: "#595959", lineHeight: 1.2 }}>{tipo}</span>
                </div>
              );
            })}
          </div>
        )}

        <Spin spinning={loading}>
          {itens.length === 0 && !loading ? (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="Nenhuma transferência pendente de confirmação. Tudo em dia. ✅"
              style={{ padding: "40px 0" }}
            />
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {itens.map((v) => {
                const nv = corTipoTransferencia(v.trans_tipo);
                return (
                  <div
                    key={v.trans_id}
                    style={{
                      display: "flex",
                      flexDirection: isMobile ? "column" : "row",
                      alignItems: "stretch",
                      borderRadius: 8, overflow: "hidden",
                      border: `1px solid ${nv.corBorda}`,
                      background: "#fff",
                      transition: "box-shadow .15s",
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.boxShadow = "0 2px 10px rgba(0,0,0,0.09)")}
                    onMouseLeave={(e) => (e.currentTarget.style.boxShadow = "none")}
                  >
                    <div style={{ width: isMobile ? "100%" : 4, height: isMobile ? 4 : "auto", background: nv.cor, flexShrink: 0 }} />

                    <div style={{ flex: 1, padding: isMobile ? "12px 14px" : "12px 16px", minWidth: 0 }}>
                      {/* Linha 1: tipo da transferência */}
                      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8, flexWrap: "wrap" }}>
                        <Tag icon={<SwapOutlined />} color={nv.cor} style={{ borderRadius: 6, fontWeight: 600 }}>
                          {v.trans_tipo || "Tipo não informado"}
                        </Tag>
                      </div>

                      {/* Linha 2: quantidade de milhas (herói, igual localizador no check-in) */}
                      <div style={{ display: "flex", alignItems: "center", gap: isMobile ? 10 : 14, flexWrap: "wrap" }}>
                        <span style={{
                          fontFamily: "'SF Mono', Menlo, Consolas, monospace",
                          fontSize: isMobile ? 15 : 17, fontWeight: 700, color: "#111",
                          letterSpacing: "0.02em",
                          background: "#f5f5f5", padding: "2px 10px", borderRadius: 6,
                          border: "1px solid #ececec",
                        }}>
                          {Number(v.tra_qtde_milhas || 0).toLocaleString("pt-BR")} milhas
                        </span>
                      </div>

                      {/* Linha 3: cliente + programa */}
                      <div style={{ display: "flex", alignItems: "center", gap: 10, marginTop: 10, flexWrap: "wrap" }}>
                        <span style={{ display: "inline-flex", alignItems: "center", gap: 7, minWidth: 0 }}>
                          <LogoCircle nome={v.car_nome_programa} size={26} />
                          <span style={{ fontSize: 13, color: "#555" }}>
                            <strong style={{ color: "#333" }}>{v.cli_nome || "—"}</strong>
                            {v.car_nome_programa ? ` · ${v.car_nome_programa}` : ""}
                          </span>
                        </span>
                      </div>
                    </div>

                    {/* Ação */}
                    <div style={{
                      display: "flex", alignItems: "center", justifyContent: isMobile ? "stretch" : "center",
                      padding: isMobile ? "10px 14px 14px" : "0 16px",
                      borderLeft: isMobile ? "none" : "1px solid #f5f5f5",
                      borderTop: isMobile ? "1px solid #f5f5f5" : "none",
                    }}>
                      <Popconfirm
                        title="Confirmar entrada da transferência?"
                        description="Isso marca esta transferência como entrada realizada e a remove da lista."
                        okText="Sim, marcar"
                        cancelText="Cancelar"
                        onConfirm={() => handleMarcar(v.trans_id)}
                      >
                        <Button
                          type="primary"
                          icon={<CheckOutlined />}
                          loading={!!marcando[v.trans_id]}
                          block={isMobile}
                        >
                          Marcar entrada
                        </Button>
                      </Popconfirm>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </Spin>
      </div>
    </div>
  );
};

export default NotificacoesTransferencia;